import React from 'react'
import { DetailItemProps } from './types'

const DetailItem: React.FC<DetailItemProps> = ({ item, children, className = '' }) => {
  return (
    <div className={`rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] ${className}`}>
      <div className="p-4">
        <div className="text-[11px] text-[hsl(var(--muted-foreground))] uppercase tracking-wider mb-2">{item.label}</div>
        <div className="text-sm font-medium text-[hsl(var(--foreground))]">{children}</div>
      </div>
    </div>
  )
}

export default DetailItem
